<template>
  <div class="wdw-forum-topics">
    <template v-if="loadingTopics">
      <div class="forum-list-skeleton" v-for="n in rows" v-bind:key="n">
        <Skeleton width="100%" height="3rem" />
      </div>
    </template>
    <template v-else-if="totalTopicsCount == 0">
      <p>Keine Bereiche gefunden</p>
    </template>

    <template v-else>
      <div class="topic-list" v-if="topics.length > 0">
        <topic-in-list
          v-for="topic in topics"
          v-bind:key="topic.id"
          :topic="topic"
          @show-topic="openTopic(topic)"
          @request-access="requestAccess(topic.id)"
        />
      </div>
    </template>

    <template v-if="totalTopicsCount">
      <Paginator :rows="rows" :totalRecords="totalTopicsCount" @page="onPageChange($event)" />
    </template>
  </div>
</template>

<script>
import { onBeforeMount, ref, watch, computed } from 'vue';

// stores
import { userStore } from '@/store/user-store';

// components
import Skeleton from 'primevue/skeleton';
import Paginator from 'primevue/paginator';
import TopicInList from '@/components/forum/elements/TopicInList.vue';

// repositories
import { RepositoryFactory } from '@/api/repositoryFactory';
const TopicRepository = RepositoryFactory.get('topic');

export default {
  name: 'forum-topics',
  props: {
    projectid: {
      type: Number,
      required: true,
    },
  },
  emit: ['show-topic', 'push-message', 'clear-messages'],

  setup(props, context) {
    const loadingTopics = ref(true);
    const rows = 10;
    const currentPage = ref(1);
    const topics = ref([]);
    const pager = ref({});

    //
    //-----------------COMPUTED------------------
    //

    const totalTopicsCount = computed(() => {
      return pager.value.total_entries;
    });

    //
    //-----------------METHODS------------------
    //

    function loadTopics(pageNummber) {
      loadingTopics.value = true;
      currentPage.value = pageNummber;
      // reset any messages on page change
      context.emit('clear-messages');
      const params = {
        projectid: props.projectid,
        rows: rows,
        page: pageNummber,
      };
      TopicRepository.get(params)
        .then(result => {
          if (result.data) {
            topics.value = result.data;
            pager.value = result.pager;
          } else {
            console.log('error');
          }
          loadingTopics.value = false;
        })
        .catch(error => {
          console.log(error);
          loadingTopics.value = false;
        });
    }
    function reloadTopics() {
      loadTopics(currentPage.value);
    }

    function onPageChange(event) {
      loadTopics(event.page + 1);
    }

    function openTopic(topic) {
      context.emit('show-topic', {
        topicid: topic.id,
        name: topic.title,
      });
    }

    function requestAccess(topicid) {
      TopicRepository.requestAccess(topicid)
        .then(resp => {
          reloadTopics();
          context.emit('push-message', { severity: 'success', content: 'Anfrage erfolgreich abgeschickt' });
        })
        .catch(err => {
          console.log(err);
          reloadTopics();
          context.emit('push-message', {
            severity: 'error',
            content: 'Bei der Anfrage ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.',
          });
        });
    }

    //
    //-----------------WATCHERS------------------
    //
    watch(
      () => userStore.getState().user,
      (newUser, oldUser) => {
        // if logged in user changes make sure to refetch data
        if ((newUser == null && oldUser) || (newUser && oldUser == null) || newUser?.id != oldUser?.id) {
          reloadTopics();
        }
      }
    );

    // initialization
    onBeforeMount(() => {
      loadTopics(1);
    });

    return {
      // REFS
      rows,
      pager,
      topics,
      loadingTopics,

      // COMPUTED
      totalTopicsCount,

      // METHODS
      onPageChange,
      openTopic,
      requestAccess,
    };
  },

  components: {
    Paginator,
    Skeleton,
    TopicInList,
  },
};
</script>

<style scoped lang="scss">
.topic-list {
  border: solid 1px #eee;
  border-top: none;
}
.forum-list-skeleton {
  padding: 10px;
}
</style>
